import { useEffect, useId, useState } from 'react'

const bus = new EventTarget()

/**
 * One open react-select at a time, portaled to document.body so a later
 * field cannot paint over the menu.
 */
export function useExclusiveMenu(portal = true) {
  const id = useId()
  const [menuIsOpen, setMenuIsOpen] = useState(false)

  useEffect(() => {
    const onOpen = (event: Event) => {
      if ((event as CustomEvent<string>).detail !== id) setMenuIsOpen(false)
    }
    bus.addEventListener('incyia-select-open', onOpen)
    return () => bus.removeEventListener('incyia-select-open', onOpen)
  }, [id])

  return {
    menuIsOpen,
    onMenuOpen: () => {
      setMenuIsOpen(true)
      bus.dispatchEvent(new CustomEvent('incyia-select-open', { detail: id }))
    },
    onMenuClose: () => setMenuIsOpen(false),
    menuPortalTarget:
      portal && typeof document !== 'undefined' ? document.body : undefined,
    menuPosition: 'fixed' as const,
    menuPlacement: 'auto' as const,
    menuShouldBlockScroll: false,
    menuShouldScrollIntoView: false,
  }
}
